<template lang="pug">
.qkb-msg-bubble-component.qkb-msg-bubble-component--single-text
  .qkb-msg-bubble-component__text.flex-col
    pre.pre-wrap {{ mainData.text }}
    slot(name="message", :data="mainData")
</template>
<script>
export default {
  props: {
    mainData: {
      type: Object
    }
  }
}
</script>
